import { useMemo } from 'react';

import { capitalize } from 'lodash-es';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { ShareFeedItem as ShareFeedItemType } from '#src/app/pages/psf/share/pageContext';

type Result = ModelHookResult<{
	altText: string;
	metaText: string;
}>;

export function useShareFeedItem(item: ShareFeedItemType): Result {
	const { translate } = useI18n();
	const channelNameMapping: Record<string, string> = useMemo(
		() => ({
			whatsapp: 'WhatsApp',
			facebookmessenger: 'facebookMessenger',
			facebook_messenger: 'Facebook Messenger',
			facebookmessage: 'Facebook Messenger',
			facebook_message: 'Facebook Messenger',
			sms: 'SMS',
			vk: 'VK',
			copylink: translate('fe.components.psf.share.share_feed.copy_link_medium'),
			mobileNativeShare: translate('fe.components.psf.share.share_feed.copy_link_medium'),
		}),
		[translate],
	);

	const channelName = useMemo(
		() => channelNameMapping[item.channel] || capitalize(item.channel),
		[channelNameMapping, item.channel],
	);

	const metaAltTextHtml = translate('fe.components.psf.share.share_feed.share_activity_text_line_1', {
		sharer_name: item.userDisplayName,
		medium: channelName,
	});

	const metaTextHtml = translate('fe.components.psf.share.share_feed.share_activity_text_line_1', {
		sharer_name: '',
		medium: channelName,
	});

	const altText = metaAltTextHtml.replace(/<[^>]+>/g, '');

	const metaText = metaTextHtml.replace(/<[^>]+>/g, '');

	return {
		data: {
			altText,
			metaText,
		},
	};
}
